module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.58.22.94362503.jpg";